// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__2hojz","primary":"Badge_primary__Whuh2","secondary":"Badge_secondary__3lYcj","tertiary":"Badge_tertiary__KofR8"};